import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap, Linear} from "gsap";
import {HTHHelper} from "../utils/HTHHelper";
import {ScatterCollector} from "./ScatterCollector";
import {GameLogo} from "./GameLogo";
import {CustomWiggle} from "gsap/dist/CustomWiggle";

export class HTHGameView extends PIXI.Container implements StageLayer {
    public scatterCollector: ScatterCollector;
    public gameLogo: GameLogo;
    private _overlay: PIXI.Sprite;

    constructor() {
        super();
        this.name = "HTHGameView";
        this.init();
    }

    public onOrientationChanged() {
        this.onResize();
    }

    public onResize(): void {
        this.resetOverlay();
        this.scatterCollector.onResizeSummoned();
        this.gameLogo.onResizeSummoned();
    }

    public resetOverlay(): void {
        const bounds = NolimitApplication.screenBounds
        this._overlay.width = bounds.width;
        this._overlay.height = bounds.height;
        this._overlay.position.x = bounds.left;
        this._overlay.position.y = bounds.top;
    }

    public addOverlay(duration: number = 0.2, alphaValue: number = 1): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            this.addChild(this._overlay);
            this.resetOverlay();
            this._overlay.alpha = 0;
            this._overlay.visible = true;
        });
        tl.to(this._overlay, {duration: duration, alpha: alphaValue});
        return tl;
    }

    public hideOverlay(dur: number = 0.2): gsap.core.Timeline {
        return gsap.timeline().to(this._overlay, {duration: dur, alpha: 0}).add(() => {
            if (this._overlay.parent) {
                this._overlay.parent.removeChild(this._overlay);
            }
            this._overlay.visible = false;
        });
    }

    public shakeEffect(dur: number, wiggles: number = 40, isVertical: boolean, movepos?: number): gsap.core.Timeline {
        let moveXVal: number = movepos ? movepos : 3,
            moveYVal: number = movepos ? movepos : 3;
        let wiggleTl: gsap.core.Timeline = gsap.timeline(),
            x: string = Math.random() > 0.5 ? `-=${moveXVal}` : `+=${moveXVal}`,
            y: string = Math.random() > 0.5 ? `-=${moveYVal}` : `-=${moveYVal}`;

        const shakeWiggle = CustomWiggle.create("shakeWiggle", {
            wiggles: wiggles,
            amplitudeEase: Linear.easeNone,
            timingEase: Linear.easeNone
        });
        if (!isVertical) {
            wiggleTl.to(this, {
                duration: dur,
                x: x,
                ease: shakeWiggle
            }, 0);
        }
        wiggleTl.to(this, {
            duration: dur,
            y: y,
            ease: shakeWiggle
        }, 0);
        wiggleTl.to(this, {
            x: 0,
            y: 0,
            duration: 0.01
        });

        return wiggleTl;
    }

    public correctLayering(): void {
        this.addChild(this.scatterCollector);
        this.addChild(this.gameLogo);
    }

    private init() {
        this.position.set(0, 0);
        this.createOverlay();
    }

    private createOverlay(): void {
        this._overlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._overlay.name = "overlay";
        this._overlay.tint = 0x000000;
        this._overlay.alpha = 0.7;
        this._overlay.visible = false;

        this.scatterCollector = new ScatterCollector();
        this.addChild(this.scatterCollector);

        this.gameLogo = new GameLogo();
        this.addChild(this.gameLogo);

        this.onResize();
    }
}